module.exports = __webpack_public_path__ + "img/logo1.4533552.png";